export default __webpack_public_path__ + "e77c37ea767fc15dea175417b0f7acda.svg";